import React from "react"
import Container from "../../atoms/Container"
import PrimaryButton from "../../atoms/Buttons/PrimaryButton"
import "./Hero.css"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import messageIcon from "../../../images/messages-2.svg"

export default function Hero({ block, pageData }) {
  const image = getImage(
    block.hero.afbeelding?.localFile?.childImageSharp?.gatsbyImageData
  )
  const imageSmall = getImage(
    block.hero.callToAction2?.afbeelding?.localFile?.childImageSharp
      ?.gatsbyImageData
  )

  console.log(pageData)

  return (
    <div
      className={`vt-hero ${
        pageData?.breadcrumb?.location == "/" ? "isHomepage" : ""
      }`}
    >
      <Container>
        <div className="vt-hero-inner">
          <div className="vt-hero-inner-left">
            <span className="vt-hero-sub-titel">{block.hero.label}</span>
            <h1 className="mb-20px">{block.hero.title}</h1>
            <p dangerouslySetInnerHTML={{ __html: block.hero.description }}></p>
            <div className="vt-hero-button-container">
              {block.hero.callToAction.link ? (
                <PrimaryButton
                  label={block.hero.callToAction.label}
                  color={"red"}
                  target={block.hero.callToAction.link}
                />
              ) : null}
              <div className="vt-hero-secundary-button">
                {imageSmall ? (
                  <GatsbyImage
                    class="vt-hero-secundary-button-img"
                    image={imageSmall}
                    objectFit="contain"
                    imgStyle={{ objectFit: "contain" }}
                  />
                ) : null}

                {block.hero.callToAction2.link ? (
                  <PrimaryButton
                    icon={block.hero.callToAction2?.icon?.localFile.publicURL}
                    iconPosition={"before"}
                    label={block.hero.callToAction2.label}
                    target={block.hero.callToAction2.link}
                  />
                ) : null}
              </div>
            </div>
          </div>
          <div className="vt-hero-inner-right">
            {image ? (
              <GatsbyImage
                className="vt-hero-inner-image"
                image={image}
                objectFit="contain"
                imgStyle={{ objectFit: "contain" }}
              />
            ) : null}
          </div>
        </div>
      </Container>
      <div className="vt-hero-devider"></div>
    </div>
  )
}
